import React from "react";
import Select from "react-select";

const MultiSelect = ({
  name,
  placeholder,
  data,
  disabled,
  defaultValueArr,
  multiSelectVal,
  setMultiSelectVal,
  multi,
}) => {

  let npRecord = [];

  // const options = multi
  // ? [{ label: "Select All", value: "all" }, ...data]
  // : data;

  return (
    <div style={{ maxWidth: '300px', minWidth: '250px' }}>
      <Select
        value={defaultValueArr ? defaultValueArr : null}
        // value={multiSelectVal}
        closeMenuOnSelect={false}
        defaultValue={defaultValueArr}
        isMulti
        placeholder={placeholder}
        options={data && data.length && data[0].value !== "" ? data : npRecord}
        // options={options}
        className="basic-multi-select"
        classNamePrefix="select"
        isSearchable={false}
        isDisabled={disabled}
        noOptionsMessage={() => "No records"}
        isClearable={true}
        onChange={(data, index) => {
          if (data !== null) {
            setMultiSelectVal(data);
            // multi &&
            // data?.length &&
            // data.find((option) => option.value === "all")
            //   ? setMultiSelectVal(options.slice(1))
            //   : !multi
            //   ? setMultiSelectVal((data && data.value) || null)
            //   : setMultiSelectVal(data);   
          }
        }}
      />
    </div>
  );
};
export default MultiSelect;
